export const LANGUAGE_STORAGE_KEY = 'erp-language';
export const SUPPORTED_LOCALES = ['en', 'es'];

export function detectBrowserLocale() {
  if (typeof navigator === 'undefined') return 'en';
  const candidates = navigator.languages?.length
    ? navigator.languages
    : [navigator.language];
  for (const raw of candidates) {
    const code = String(raw || '').toLowerCase().split('-')[0];
    if (code === 'es') return 'es';
    if (code === 'en') return 'en';
  }
  return 'en';
}

export function formatMessage(template, vars = {}) {
  if (!template || typeof template !== 'string') return template ?? '';
  return template.replace(/\{(\w+)\}/g, (_, key) => {
    const val = vars[key];
    return val === undefined || val === null ? `{${key}}` : String(val);
  });
}
